import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Eye, Trash2, PenLine, Info, FileDown, Navigation } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useCallback, useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { TabsContent } from "@/components/ui/tabs";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "@/components/lib/Pagination";
import { clearVoucherHistoryMessages, setVoucherHistorySearch, setVoucherHistoryCurrentPage, setVoucherHistoryPerPage, setVoucherHistoryStatus, deletePointBasedOfferHistoryById } from "@/redux/slice/loyalty/PointBasedOfferHistorySlice";
import { Button } from "@/components/ui/button";
import { CustomerInfoDialog, DeleteConfirmDialog } from "@/components/dialog/common-dialog";
import { toast } from "react-hot-toast";
import CommonSendVia from "../CommonSendVia";
import ViewPointBasedReward from "./ViewPointBasedReward";
import { fetchLoyaltyTemplates } from "@/redux/slice/loyalty/templeteSlice";
import { exportPointBasedTemplatePdf } from "@/lib/export-point-based-template-pdf";
import { printPdfFromUrl } from "@/lib/download";

function PointBasedRewardHistoryTab() {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [itemsDialog, setItemsDialog] = useState(null);

  const { voucherHistoryStatus, voucherHistories, voucherHistoryCurrentPage, totalVoucherHistoryPages, searchVoucherHistory, voucherHistoryPerPage, getVoucherHistoryLoading } = useSelector(
    (state) => state.loyalty.pointBasedOfferHistory
  );
  
  // Handlers
  const handleSearchChange = useCallback(
    (e) => {
      dispatch(setVoucherHistorySearch(e.target.value));
      //Remove it, if want in same page search
      dispatch(setVoucherHistoryCurrentPage(1));
    },
    [dispatch]
  );

  // Send voucher via
  const [isSendVoucherViaModalOpen, setIsSendVoucherViaModalOpen] = useState(false);
  const [selectedSendVoucherViaOptions, setSelectedSendVoucherViaOptions] = useState([]);
  const closeSendVoucherVia = () => {
    setIsSendVoucherViaModalOpen(false); 
    setItemsDialog(null)
  };

  const handlePrintExport = async (rowData) => {
    if (!rowData) return;

    try {
      const pointBaseCard = rowData?.point_base_card || rowData;
      const restaurantId = pointBaseCard?.restaurant_id || rowData?.restaurant_id;

      if (!restaurantId) {
        toast.error("Restaurant ID not found for export.");
        return;
      }

      const templateList = await dispatch(
        fetchLoyaltyTemplates({
          restaurant_id: restaurantId,
          type: "point",
          per_page: 10,
        }),
      ).unwrap();

      await exportPointBasedTemplatePdf({
        selectedPointBased: rowData,
        templates: templateList,
        fileName: `${pointBaseCard?.code || "point-based-history"}.pdf`,
      });

      toast.success("Point-based reward exported successfully.");
    } catch (error) {
      toast.error(error?.message || "Failed to export point-based reward PDF.");
    }
  };

  const handleConfirm = async (selected) => {
    const selectedRow = itemsDialog;
    setSelectedSendVoucherViaOptions([]);

    if (selected?.includes("Print")) {
      await handlePrintExport(selectedRow);
      return true;
    }

    if (selected?.includes("EMAIL")) {
      toast("Email sending is not configured for point-based history items.");
      return false;
    }

    return true;
  };

  // View customer
  const [isSingleVoucherModalOpen, setIsSingleVoucherModalOpen] = useState(false);
  const closeSingleVoucher = () => {
    setIsSingleVoucherModalOpen(false); 
    setItemsDialog(null)
  };

  const [customerInfoDialog, setCustomerInfoDialog] = useState(false);
  const closeCustomerInfo = () => {
    setCustomerInfoDialog(false);
    setItemsDialog(null);
  };

  return (
    <TabsContent value="pointBasedRewardHistory">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="flex gap-4">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2 left-2"
              />
              <Input
                ref={inputRef}
                value={searchVoucherHistory}
                onChange={handleSearchChange}
                placeholder="Search"
                className="bg-cblack3 pl-8"
              />
            </div>
            {/* <div className="relative">
              <Select>
                <SelectTrigger className="w-[150px]">
                  <SelectValue placeholder="Template Name" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="1">1</SelectItem>
                  <SelectItem value="2">2</SelectItem>
                  <SelectItem value="3">3</SelectItem>
                </SelectContent>
              </Select>
            </div> */}
            {/* <div className="relative">
              <Select
                value={voucherHistoryStatus}
                onValueChange={(value) => {
                dispatch(setVoucherHistoryStatus(value === "0" ? "" : value))
                dispatch(setVoucherHistoryCurrentPage(1))
              }}>
                <SelectTrigger className="w-[100px]">
                  <SelectValue placeholder="Status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="0">All</SelectItem>
                  <SelectItem value="pending">Pending</SelectItem>
                  <SelectItem value="used">Used</SelectItem>
                  <SelectItem value="expired">Expired</SelectItem>
                </SelectContent>
              </Select>
            </div> */}
          </div>

          <div className="flex flex-col gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              <Button
                className={"bg-cblack3 border border-gray-600 text-cwhite2"}
              >
                <FileDown /> Export
              </Button>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  value={String(voucherHistoryPerPage)}
                  onValueChange={(value) => {
                    dispatch(setVoucherHistoryPerPage(Number(value)))
                    dispatch(setVoucherHistoryCurrentPage(1))
                  }}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder={String(voucherHistoryPerPage)} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
        </div>
        {/* table start */}
        <Table className="w-full mt-5">
          <TableHeader>
            <TableRow>
              <TableHead>Customer ID</TableHead>
              <TableHead>Customer Details</TableHead>
              <TableHead>Eligible Reward</TableHead>
              <TableHead>Used Code</TableHead>
              <TableHead>Used Points</TableHead>
              <TableHead>Remaining Points</TableHead>
              <TableHead>Used Date</TableHead>
              <TableHead className="text-right">Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {voucherHistories && voucherHistories?.length > 0 ? (
              voucherHistories?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {item?.customer_id || "N/A"}
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2 h-8">
                      {item?.customer_full_name}
                      <Info 
                        onClick={() => {
                          setCustomerInfoDialog(true);
                          setItemsDialog(item);
                        }}
                        size={20}
                        className="text-cwhite3 cursor-pointer"
                      />
                    </div>
                  </TableCell>
                  <TableCell>
                    {item?.point_base_card?.eligible_reward_points ?? item?.eligible_reward_points ?? "N/A"}
                  </TableCell>
                  <TableCell>{item?.short_code}</TableCell>
                  <TableCell>{item?.used_points}</TableCell>
                  <TableCell>{item?.remaining_points}</TableCell>
                  <TableCell>{item?.used_at}</TableCell>
                  <TableCell className="text-right justify-end flex gap-2 items-center">
                    <div className="flex items-center gap-2 h-8">
                      <Eye
                        onClick={() => {
                          setIsSingleVoucherModalOpen(true)
                          setItemsDialog(item);
                        }}
                        className="text-cwhite3 cursor-pointer"
                        size={20}
                      />

                      <Navigation
                        onClick={() => {
                          setIsSendVoucherViaModalOpen(true)
                          setItemsDialog(item);
                        }}
                        className="text-cwhite3 cursor-pointer"
                        size={20}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} className="text-center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className="flex justify-start mt-4">
          <Pagination
              currentPage={voucherHistoryCurrentPage} 
              totalPages={totalVoucherHistoryPages} 
              onPageChange={(e)=>dispatch(setVoucherHistoryCurrentPage(e))} 
          />
        </div>
      </div>
      <CommonSendVia
        isOpen={isSendVoucherViaModalOpen}
        onClose={closeSendVoucherVia}
        title="Send Voucher via"
        options={[
          // "Whatsapp",
          // "SMS",
          "EMAIL",
          "Print",
        ]}
        value={selectedSendVoucherViaOptions}
        onChange={setSelectedSendVoucherViaOptions}
        onPrint={async () => {
          const pointBaseCard = itemsDialog?.point_base_card || itemsDialog;
          const pdfUrl =
            itemsDialog?.pdf_url ||
            pointBaseCard?.pdf_url ||
            itemsDialog?.point_base_card?.pdf_url ||
            null;

          if (!pdfUrl) {
            toast.error("PDF URL not found for printing.");
            return false;
          }

          printPdfFromUrl(pdfUrl);
          toast.success("Point-based reward opened for printing.");
          return true;
        }}
        onConfirm={handleConfirm}
      />

      <ViewPointBasedReward
        isOpen={isSingleVoucherModalOpen}
        onClose={closeSingleVoucher}
        selectedVoucher={itemsDialog}
      />
      <CustomerInfoDialog
        items={itemsDialog}
        isOpen={customerInfoDialog}
        onClose={closeCustomerInfo}
      />
    </TabsContent>
  );
}

export default PointBasedRewardHistoryTab;